export const categoryList = {
    music: {
        category: 'music',
        name: '乐',
        desc: '一些音乐和乐队的评价和介绍，主要是为了满足我安利的欲望。',
    },
    prose: {
        category: 'prose',
        name: '文',
        desc: '一些碎碎念。',
    },
    tech: {
        category: 'tech',
        name: '术',
        desc: '一些看了好像也没有什么用的技术文章。',
    },
    works: {
        category: 'works',
        name: '作',
        desc: '一些曾经的习作和未来会写的习作。',
    },
}